import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer className="bg-espresso text-cream py-16 md:py-20" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-3 gap-12 items-start border-b border-cream/15 pb-14">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="Klean With Katie" className="h-20 w-20 object-contain rounded-full bg-cream/5" />
            <span className="leading-tight">
              <span className="block font-serif text-2xl">Klean <span className="italic text-blush">with</span> Katie</span>
              <span className="block text-[10px] uppercase tracking-[0.22em] text-cream/60">Clean Spaces, Happy Faces</span>
            </span>
          </div>
          <p className="text-cream/50 font-light max-w-xs">Making homes sparkle — bespoke, meticulous cleaning delivered with intention and care.</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-blush mb-5">Explore</p>
          <ul className="space-y-3 text-cream/70 font-light">
            {["about", "services", "gallery", "testimonials", "contact"].map((id) => (
              <li key={id}>
                <button
                  data-testid={`footer-${id}-link`}
                  onClick={() => scrollToId(id)}
                  className="capitalize hover:text-blush transition-colors duration-300"
                >
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-blush mb-5">Get in touch</p>
          <ul className="space-y-3 text-cream/70 font-light">
            <li><a href="tel:07562245578" data-testid="footer-phone-link" className="hover:text-blush transition-colors duration-300">07562 245578</a></li>
            <li><a href="https://www.instagram.com/klean_withkatie?igsi=MW52YW45YWt3ejhncA%3D%3D&utm_source=qr" target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="hover:text-blush transition-colors duration-300">Instagram · @klean_withkatie</a></li>
            <li><a href="https://www.facebook.com/share/1D36HFTaeK/?mibextid=wwXIfr" target="_blank" rel="noreferrer" data-testid="footer-facebook-link" className="hover:text-blush transition-colors duration-300">Facebook · @KleanwithKatie</a></li>
            <li><a href="https://www.tiktok.com/@kleanwithkatie3?_r=1&_t=ZN-998Fb48LmLe" target="_blank" rel="noreferrer" data-testid="footer-tiktok-link" className="hover:text-blush transition-colors duration-300">TikTok · @kleanwithkatie3</a></li>
          </ul>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs uppercase tracking-[0.18em] text-cream/40">
        <span>© {new Date().getFullYear()} Klean With Katie</span>
        <span>Crafted with care</span>
      </div>
    </div>
  </footer>
);
